import { edi } from '@/requests';
import { deleteRequest } from '@/core';

export default async function(edipartId) {
	let url = edi.deleteEdipart(edipartId);
	let response = await deleteRequest(url, '', {});
	return response;
}